module.exports = __webpack_public_path__ + "static/media/gls_leg_r.fdd9d5f1.png";